<template>
      <body class="overflow-hidden">
        <div class="mx-4 md:mx-12 py-3 lg:py-8 md:py-12 grid place-content-center px-4 md:px-0">
            <div class="lg:flex justify-start lg:gap-28">
                <div class="">
                    <h1 class="font-bold text-3x1 lg:text-5xl text-white text-left">Hours of work = 50+/week</h1>
                    <p class="pt-3 lg:pt-8 md:pt-4 text-indigo-300 text-left">We are open from Monday to Friday at 08:00hrs to 17:00hrs and 08:00hrs to 13:00hrs on Saturdays.</p>
                    
                    
                </div>
                <div class="pt-8 lg:pt-0">
                    <img src="@/images/hours.png" alt="man in black suit holding brown paper" class="hidden lg:block" />
                    <img src="" alt="man in black suit holding brown paper" class="hidden sm:block lg:hidden" />
                    <img src="@/images/hours.png" alt="man in black suit holding brown paper" class="sm:hidden" />
                </div>
            </div>
        </div>
    </body>
</template>

<script>
export default {

}
</script>

<style>

</style>